import React, { useEffect, useRef, useState } from "react";
import FooterSmallNew from "components/Footers/FooterSmallNew";
import Footer from "components/Footers/Footer";
import { useTranslation } from "react-i18next";
import { useLanguage } from "components/Homepage/LanguageContext";
import IndexNavbar2 from "components/Navbars/IndexNavbar2";
import contactus from "assets/img/contactus.jpg";

import ContactForm from "about/aboutpage/ContactForm";
import contactuss from "assets/img/contact-uss.webp";

const Contactus = () => {
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();

  // Scroll down animation
  const sections = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    sections.current.forEach((section) => {
      if (section && section instanceof Element) {
        observer.observe(section);
      }
    });

    const handleScroll = debounce(() => {
      sections.current.forEach((section) => {
        if (section && section instanceof Element) {
          observer.observe(section);
        }
      });
    }, 100);

    window.addEventListener("scroll", handleScroll);

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }

  return (
    <section>
      <IndexNavbar2 />
      <section className="xl:pt-28 lg:pt-28 md:pt-17 pt-17"></section>
      <section
        ref={(el) => sections.current.push(el)}
        style={{
          position: "relative",
          backgroundImage: `url(${contactus})`,
          width: "100%",

          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="animate-on-scroll xl:h-450 lg:h-300 md:h-300 justify-center text-white"
      >
        <div className="">
          <div className="container mx-auto overflow-hidden hometext xl:px-24 px-4">
            <div className="grid md:grid-cols-2 ">
              <div className="text-left bg-dark-blue xl:p-16 lg:p-14 md:p-12 p-12">
                <h1 className="banner-font text-white xl:pt-17 pt-1 font-extrabold xl:text-head1 lg:text-head1 headlineheight md:text-head1 text-head1 md:text-xl text-2xl">
                  {t("contactcontent1")}
                </h1>
                <p className="pt-2 xl:pt-2 text-white xl:mb-22 lg:mb-8 md:mb-6 banner-font xl:text-lg text-lg">
                  {t("contactcontent2")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        ref={(el) => sections.current.push(el)}
        style={{
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="animate-on-scroll"
      >
        <div className="container xl:px-24 xl:pt-16 xl:pb-0 lg:pb-12 md:pb-12 pb-8 pt-12 px-4 mx-auto">
          <div className="xl:w-12/12 w-12/12 md:flex flex-none">
            <div className="xl:w-5/12 lg:w-5/12 md:w-5/12">
              <img
                alt="Your browser doe not supoort this image"
                src={contactuss}
                className="round-style w-full xl:mb-24"
              />
            </div>

            <div className="xl:w-8/12 lg:w-7/12 md:w-7/12 w-12/12 xl:mb-24 bg-light-sky xl:p-8 lg:p-8 md:p-8 p-0 xl:ml-8 md:ml-4 ml-0 md:mt-0 mt-4">
              <div>
                <div className="">
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FooterSmallNew />
    </section>
  );
};
export default Contactus;
